
const config = {
    apiUrl: "https://api.nepidkupnist.in.ua", // http://localhost:8000   http://api.nepidkupnist.in.ua
    apiPort: 8000
};

export default config;